/** @format */
import { ModelPriceModifierGroup } from '@toucan/client/global/model';

export function getIncludedAccessories(
    groups: ModelPriceModifierGroup[] = [],
    availableModifierIds: number[] = []
) {
    return groups
        .filter((group) => group.isEssential && group.modifiers.length > 1)
        .map((group) => ({
            ...group,
            modifiers: group.modifiers.filter((modifier) =>
                availableModifierIds.includes(modifier.id)
            ),
        }))
        .filter((group) => group.modifiers.length > 0);
}

export function getDefaultSelectedIncludedAccessories(
    includedAccessories: ModelPriceModifierGroup[]
) {
    return includedAccessories.reduce<ModelPriceModifierGroup['modifiers']>(
        (previousValue, { modifiers }) => {
            if (modifiers.length === 1) {
                previousValue.push(modifiers[0]);
            }
            return previousValue;
        },
        []
    );
}

export function getExtraAccessories(
    groups: ModelPriceModifierGroup[] = [],
    availableModifierIds: number[] = []
) {
    return groups
        .reduce<ModelPriceModifierGroup['modifiers']>(
            (accessories, currentGroup) => {
                if (!currentGroup.isEssential) {
                    accessories.push(...currentGroup.modifiers);
                }
                return accessories;
            },
            []
        )
        .filter((modifier) => availableModifierIds.includes(modifier.id));
}
